import getCookie from '~/lib/getCookie'
import countries from '~/data/countries.json'

const countriesByShortCode = Object.fromEntries(
  countries.map((item) => [item.countryShortCode, item])
)

export default function getCountryData(fallbackLocale) {
  const geoCookie = getCookie('inseegoGeo')
  if (geoCookie) {
    return countriesByShortCode[geoCookie]
  }
  if (fallbackLocale) {
    const [_, localeCountry] = fallbackLocale.split('-')
    return countriesByShortCode[localeCountry]
  }
}
